import { type Product } from '@/mocks/products';
import { products } from '@/mocks/products';
import ProductCard from '@/components/base/ProductCard';

interface RelatedProductsProps {
  currentProduct: Product;
}

export default function RelatedProducts({ currentProduct }: RelatedProductsProps) {
  const related = products
    .filter(p => p.id !== currentProduct.id)
    .map(p => {
      let score = 0;
      if (p.petType === currentProduct.petType) score += 2;
      if (p.functionCategory === currentProduct.functionCategory) score += 3;
      if (p.material === currentProduct.material) score += 1;
      return { product: p, score };
    })
    .sort((a, b) => b.score - a.score)
    .slice(0, 4)
    .map(item => item.product);

  if (related.length === 0) return null;

  return (
    <section className="mt-12 md:mt-16">
      <div className="flex items-center gap-2 mb-6">
        <span className="w-5 h-5 flex items-center justify-center">
          <i className="ri-footprint-line text-accent-500"></i>
        </span>
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
          You May Also Like
        </h2>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5">
        {related.map(product => (
          <ProductCard key={product.id} product={product} variant="compact" />
        ))}
      </div>
    </section>
  );
}